export default {
  // 디버그 모드
  debug: false,

  // 인증 제한 시간
  limit_min: 5,

  // 폴링 설정
  polling: {
    interval: 1000, // 폴링 주기
    maintain: 300000, // 초기 폴링 주기를 유지하는 기간
    slow: 30000, // 초기 폴링 유지시간을 지나고부터 주기가 느려지는 주기
  },

  // 이미지 Storage 설정
  image: {
  url: 'https://metapass-dev.metadium.club/public/images/web/', // storage 주소
    stage: { low: '_low', high: '_high' }, // 저해상도와 고해상도 이미지의 suffix
  },
};
